import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SocialLinksComponent } from './components/social-links/social-links.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { BookNowComponent } from './components/book-now/book-now.component';
import { HomeComponent } from './pages/home/home.component';

import { WindowService } from './window-service.service';
import { ShopOnlineComponent } from './components/shop-online/shop-online.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SocialLinksComponent,
    AboutUsComponent,
    BookNowComponent,
    HomeComponent,
    ShopOnlineComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [WindowService],
  bootstrap: [AppComponent]
})
export class AppModule { }
